import React from 'react'
import InventoryOptionsView from '../../containers/Inventory/InventoryOptions/InventoryOptions'

const InventoryOptions = () => {
    return (
        
        <InventoryOptionsView />
        
    )
}

export default InventoryOptions
